<template>
  <div class="evalua_page-root stu_create_evalua-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim=true" class="nav-wrap">
        <p class="title">
          <span v-if="classInfo.is_special_train === 1">【快】</span>
          {{classInfo.name}}
        </p>
      </yioks-page-nav>
      <div class="content-wrap">
        <div class="info-show evaluat_user-root">
          <div class="avator">
            <img
              class="img"
              :src="isImgLoadErr ? $options._myOpt.momentCover:classInfo.moment_picture"
              @error="isImgLoadErr = true"
            >
          </div>
          <div class="info">
            <p  v-if="['C', 'D', 'early','L1','L2','L3' ].includes( classInfo.class_level)">培训日期：{{classInfo.start_date | time(false)}} 至 {{classInfo.end_date | time(false)}}</p>
            <div style="display: flex;align-items: center" v-if="classInfo.class_level==='A' || classInfo.class_level ==='B' || classInfo.class_level ==='PRO' || classInfo.class_train_type === 'physical_train' || classInfo.class_train_type === 'goalkeeper_train' ">
              
              <template v-if="dataPhase.start_date">
                <p>培训第一阶段：{{dataPhase.start_date | time(false)}} 至 {{dataPhase.end_date | time(false)}}</p>
                <p style="margin-left: 30px ">培训第二阶段：{{dataPhase.start_date1 | time(false)}} 至 {{dataPhase.end_date1 | time(false)}}</p>
              </template>
              <template v-else>
                <p>培训日期：{{classInfo.start_date | time(false)}} 至 {{classInfo.end_date | time(false)}}</p>
              </template>
            </div>
            <p>训练场地：{{classInfo.training_address}}</p>
            <p>理论课场地：{{classInfo.theory_address}}</p>
            <p>
              <span>培训机构：{{classInfo.org_name}}</span>
              <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
              <span>主讲师：{{classInfo.teacher_off_name}}</span>
              <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
              <span v-if="classInfo.teacher_name">助理讲师：{{classInfo.teacher_name}}</span>
              <span> &nbsp;&nbsp;&nbsp;&nbsp; </span>
              <span v-if="classInfo.lecturer_assistant_name">讲师助理：{{classInfo.lecturer_assistant_name}}</span>
            </p>
          </div>
        </div>
        <!-- <p class="evalua-tip">该问卷调查将直接提交至中国足协且为匿名方式，调查结果只有中国足协培训负责人可以看到，任何讲师和培训组织方均看不到调查结果，请大家依据实际情况填写。<br>本问卷调查目的在于请所有学员对讲师、培训组织方做出真实、客观评价，形成监督、反馈机制，有助于中国足协进一步改善教练员培训工作。<br/>中国足协感谢您为中国足球的发展做出的努力。</p> -->
        <div class="evalua-wrap">
          <div class="scroll-wrap">
            <vue-scroll :ops="$options._myOpt.vuescrollOpt">
              <div class="scroll-content">
                <p class="evalua-tip">&emsp;&emsp;该问卷调查将直接提交至中国足协且为匿名方式，调查结果只有中国足协培训负责人可以看到，任何讲师和培训组织方均看不到调查结果，请大家依据实际情况填写。本问卷调查目的在于请所有学员对讲师、培训组织方做出真实、客观评价，形成监督、反馈机制，有助于中国足协进一步改善教练员培训工作。中国足协感谢您为中国足球的发展做出的努力。</p>
                <div class="evaluat-box">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对机构{{orgEvaluatRes.name}}的问卷调查</span>
                  </div>
                  
                  <div style="display:flex">
                    <div>
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        您对理论课教室的满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.theory_room_score"></yioks-rating>
                    </div>
                    <div>
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        您对实践课场地的满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.practice_room_score"></yioks-rating>
                    </div>
                  </div>
                  <div style="display:flex">
                    
                    <div>
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        您对食宿条件的满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.eat_sleep_score"></yioks-rating>
                    </div>
                    <div>
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        您对培训服装的满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.train_clothing_socre"></yioks-rating>
                    </div>
                  </div>
                  <div style="display:flex">
                    <div v-if="['GB','GA','F1','F2','B','A','PRO'].includes(orgEvaluatRes.class_level)">
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        您对实践队伍的满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.practice_team_score"></yioks-rating>
                    </div>
                    <div>
                      <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                        对{{orgEvaluatRes.name}}的综合满意度
                      </div>
                      <yioks-rating class="rating" :star-num.sync="orgEvaluatRes.starNum"></yioks-rating>
                    </div>
                  </div>
                  
                  <div v-if="orgEvaluatRes.contsList.length>0">
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="orgEvaluatRes.contsList"></yioks-evaluation>
                  </div>
                  <template v-if="orgEvaluatRes.eva_data_choose.length>0">
                    <p class="cont-title">选择以下现象</p>
                    <div class="cont_evalua-root">
                      <div class="item-wrap evaluation_checked" v-for="(it) in orgEvaluatRes.eva_data_choose" :key="it.id" style="display:flex;margin-bottom:10px;width:100%">
                        <div style="display:flex;align-items: flex-start;width:100%">
                          <div style="width:32%">
                            <span style="color:#f88594;margin-right:2px">*</span><span :title="it.text" >{{it.text}}</span>
                          </div>
                          <div style="margin-left:10px;width:20%" >
                            <el-radio-group v-model="it.is_option" @change="(it.content = '')">
                              <el-radio  label="是" border >是</el-radio>
                              <el-radio  label="否" border >否</el-radio>
                            </el-radio-group>
                          </div>
                          <div style="width:44%" v-show="(it.write_content ==='是' && it.is_option==='是') || (it.write_content ==='否' && it.is_option==='否' )">
                            <el-input v-model="it.content" placeholder="请输入内容，必填" maxlength="100" show-word-limit></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <p class="cont-title">其他意见或建议</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="orgEvaluatRes.suggest"
                      rows="2"
                      placeholder="如有其他意见或建议，请输入内容，没有意见可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{orgEvaluatRes.suggest.length}}/100</span>
                  </div>
                </div>
                <div class="evaluat-box" v-for="item in teaEvaluatResClass" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对培训班整体情况的问卷调查</span>
                  </div>
                  <!--<yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>-->
                  <template v-if="item.contsList.length>0">
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </template>
                  <template v-if="item.eva_data_choose.length>0">
                    <p class="cont-title">选择以下现象</p>
                    <div class="cont_evalua-root">
                      <div class="item-wrap evaluation_checked" v-for="(it) in item.eva_data_choose" :key="it.id" style="display:flex;margin-bottom:10px;width:100%">
                        <div style="display:flex;align-items: flex-start;width:100%">
                          <div style="width:38%">
                            <span style="color:#f88594;margin-right:2px">*</span><span :title="it.text" >{{it.text}}</span>
                          </div>
                          <div style="margin-left:10px;width:20%" >
                            <el-radio-group v-model="it.is_option" @change="(it.content = '')">
                              <el-radio  label="是" border >是</el-radio>
                              <el-radio  label="否" border >否</el-radio>
                            </el-radio-group>
                          </div>
                          <div style="width:38%" v-show="(it.write_content ==='是' && it.is_option==='是') || (it.write_content ==='否' && it.is_option==='否' )">
                            <el-input v-model="it.content" placeholder="请输入内容，必填" maxlength="100" show-word-limit></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <p class="cont-title">情况反馈</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如有其他情况反馈，请输入内容，没有可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
                <div class="evaluat-box" v-for="item in teaEvaluatResLinkMan">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对协调员的问卷调查</span>
                  </div>
                  <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                    对协调员的综合满意度
                  </div>
                  <yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>
                  <div v-if="item.contsList.length>0">
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </div>
                  <template v-if="item.eva_data_choose.length>0">
                    <p class="cont-title">选择以下现象</p>
                    <div class="cont_evalua-root">
                      <div class="item-wrap evaluation_checked" v-for="(it) in item.eva_data_choose" :key="it.id" style="display:flex;margin-bottom:10px;width:100%">
                        <div style="display:flex;align-items: flex-start;width:100%">
                          <div style="width:38%">
                            <span style="color:#f88594;margin-right:2px">*</span><span :title="it.text" >{{it.text}}</span>
                          </div>
                          <div style="margin-left:10px;width:20%" >
                            <el-radio-group v-model="it.is_option" @change="(it.content = '')">
                              <el-radio  label="是" border >是</el-radio>
                              <el-radio  label="否" border >否</el-radio>
                            </el-radio-group>
                          </div>
                          <div style="width:38%" v-show="(it.write_content ==='是' && it.is_option==='是') || (it.write_content ==='否' && it.is_option==='否' )">
                            <el-input v-model="it.content" placeholder="请输入内容，必填" maxlength="100" show-word-limit></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <p class="cont-title">您对协调员的意见或建议</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如有其他情况反馈，请输入内容，没有可不填。"
                      class="textarea"
                      maxlength="100"
                    ></textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
                <div class="evaluat-box" v-for="item in teaEvaluatRes" :key="item.id">
                  <div class="title">
                    <v-icon class="icon" name="regular/edit" scale="2"></v-icon>
                    <span class="text">对{{item.type}}{{item.name}}的问卷调查</span>
                  </div>
                  <div style="text-align: center;font-size: 18px;margin-bottom: 10px;">
                    对{{item.type}}{{item.name}}的综合满意度
                  </div>
                  <yioks-rating class="rating" :star-num.sync="item.starNum"></yioks-rating>
                  <div v-if="item.contsList.length>0">
                    <p class="cont-title">如存在以下现象请勾选</p>
                    <yioks-evaluation class="cont-box" :conts-list.sync="item.contsList"></yioks-evaluation>
                  </div>
                  <template v-if="item.eva_data_choose.length>0">
                    <p class="cont-title">选择以下现象</p>
                    <div class="cont_evalua-root">
                      <div class="item-wrap evaluation_checked" v-for="(it) in item.eva_data_choose" :key="it.id" style="display:flex;margin-bottom:10px;width:100%">
                        <div style="display:flex;align-items: flex-start;width:100%">
                          <div style="width:38%">
                            <span style="color:#f88594;margin-right:2px">*</span><span :title="it.text" >{{it.text}}</span>
                          </div>
                          <div style="margin-left:10px;width:20%" >
                            <el-radio-group v-model="it.is_option" @change="(it.content = '')">
                              <el-radio  label="是" border >是</el-radio>
                              <el-radio  label="否" border >否</el-radio>
                            </el-radio-group>
                          </div>
                          <div style="width:38%" v-show="(it.write_content ==='是' && it.is_option==='是') || (it.write_content ==='否' && it.is_option==='否' )">
                            <el-input v-model="it.content" placeholder="请输入内容，必填" maxlength="100" show-word-limit></el-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                  <p class="cont-title">对讲师的意见或建议</p>
                  <div class="textarea-wrap">
                    <textarea
                      autocomplete="off"
                      v-model="item.suggest"
                      rows="2"
                      placeholder="如对有讲师的意见或建议，请输入内容，没有意见可不填。"
                      class="textarea"
                      maxlength="100"
                    >
                    </textarea>
                    <span class="length-tip">{{item.suggest.length}}/100</span>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="post-btn">
        <div class="btn save" @click="tipsFlag=true">匿名提交</div>
        <div class="btn cancel" @click="goBack">取消</div>
      </div>
      <yioks-tips :showTips="backComfim" tips="确定放弃修改并返回吗？" @hideTips="backComfimDialog"></yioks-tips>
      <yioks-tips :showTips="tipsFlag" :tips="$options._myOpt.tipMsg" @hideTips="hideTipsDialog"></yioks-tips>
    </div>
  </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { correctStatus } from "@/assets/js/apiStatus";
import { getStuRatingInfo, saveEvaluat } from "@/api/training_student/api";
import momentCover from "@/assets/images/class_logo.png";
import {
  transContsList,
  transData,
  paramsEvalData
} from "@/assets/js/evaluation";
const HOSTURL = process.env.VUE_APP_URL;
const SPLIT_CHAR = ",";

export default {
  name: "StuCreateEvaluation",
  _myOpt: {
    vuescrollOpt: createScrollOpt(),
    momentCover,
    tipMsg: "匿名提交后不可更改，是否确定提交？"
  },
  props: {},
  components: {
    "v-icon": Icon,
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-rating": () => import("@/components/Rating/Rating"),
    "yioks-evaluation": () => import("@/components/EvaluaConts/EvaluaConts"),
    "yioks-tips": () => import("@/components/Tips/Dialog")
  },
  created() {
    this.ratingInfo();
  },
  data() {
    return {
      tipsFlag: false,
      backComfim: false,
      classInfo: {},
      dataPhase:{},
      isImgLoadErr: false,
      classId:this.$route.query.c_id,
      orgEvaluatRes: {
        name: "",
        starNum: 0,
        theory_room_score: 0,
        practice_room_score: 0,
        eat_sleep_score: 0,
        practice_team_score: 0,
        train_clothing_socre: 0,
        suggest: "",
        contsList: [],
        eva_data_choose: [],
      },
      teaEvaluatRes: [],
      teaEvaluatResClass: [],
      teaEvaluatResLinkMan: [],
    };
  },
  methods: {
    backComfimDialog(bool, sure) {
      this.backComfim = bool;
      if (sure) {
        this.$router.push({
        path: "/student/class_detail"
      });
      } else {
      }
    },
    // 是否确定提交数据弹窗
    hideTipsDialog(bool, sure) {
      this.tipsFlag = bool;
      if (sure) {
        // 提交数据
        this.saveEvaluat();
      } else {
      }
    },
    saveEvaluat() {
  
      // 培训机构的 选择是否的判断 必须选
      if(this.orgEvaluatRes.eva_data_choose.some(({ is_option }) => is_option === '')){
        this.$message.error("请选择带 * 的必选项。");
        return;
      }
      if(this.orgEvaluatRes.eva_data_choose.some(({ is_option,content,write_content }) => (is_option !== '' && is_option ===write_content && content ===''))){
        this.$message.error("请填写带 * 的选项内容");
        return;
      }
  
      // 选择是否的判断 必须选
      let ab = 0; // 选项是否选择
      let ac = 0; // 如需要填内容 是否填了
      //  培训班整体情况的的是否判断
      this.teaEvaluatResClass.map(item=>{
        item.eva_data_choose.map(it=>{
          if(it.is_option === ''){
            ab = 1;
          }
          if(it.is_option !== '' && it.is_option ===it.write_content && it.content ===''){
            ac = 1;
          }
        })
      })
  
      let ad = 0; // 选项是否选择
      let ae = 0; // 如需要填内容 是否填了
      //  培训班协调员的的是否判断
      this.teaEvaluatResLinkMan.map(item=>{
        item.eva_data_choose.map(it=>{
          if(it.is_option === ''){
            ad = 1;
          }
          if(it.is_option !== '' && it.is_option ===it.write_content && it.content ===''){
            ae = 1;
          }
        })
      })
  
      let af = 0; // 选项是否选择
      let ag = 0; // 如需要填内容 是否填了
      //  讲师的是否判断
      this.teaEvaluatRes.map(item=>{
        item.eva_data_choose.map(it=>{
          if(it.is_option === ''){
            af = 1;
          }
          if(it.is_option !== '' && it.is_option ===it.write_content && it.content ===''){
            ag = 1;
          }
        })
      })
      if(ab || ad || af){
        this.$message.error("请选择带 * 的必选项。");
        return;
      }
      if(ac || ae || ag){
        this.$message.error("请填写带 * 的选项内容");
        return;
      }
      
      const { orgEvaluatRes, teaEvaluatRes,teaEvaluatResClass,teaEvaluatResLinkMan } = this;
      const teaEvalData = paramsEvalData(teaEvaluatRes);
      const evalDataClass = paramsEvalData(teaEvaluatResClass);
      const evalDataLinkMan = paramsEvalData(teaEvaluatResLinkMan);
      if (
        orgEvaluatRes.starNum === 0 ||
        orgEvaluatRes.theory_room_score === 0 ||
        orgEvaluatRes.practice_room_score === 0 ||
        orgEvaluatRes.eat_sleep_score === 0 ||
        (orgEvaluatRes.practice_team_score === 0 && ['GB','GA','F1','F2','B','A','PRO'].includes(orgEvaluatRes.class_level)) ||
        orgEvaluatRes.train_clothing_socre === 0 ||
        teaEvalData.some(({ star }) => star === 0) ||
        evalDataLinkMan.some(({ star }) => star === 0)
      ) {
        this.$message.error("星级评价为必评项");
        return;
      }
      const orgEvalData = {
        star: orgEvaluatRes.starNum,
        theory_room_score: orgEvaluatRes.theory_room_score,
        practice_room_score: orgEvaluatRes.practice_room_score,
        eat_sleep_score: orgEvaluatRes.eat_sleep_score,
        practice_team_score: orgEvaluatRes.practice_team_score,
        train_clothing_socre: orgEvaluatRes.train_clothing_socre,
        other_eva: orgEvaluatRes.suggest,
        tag_list: orgEvaluatRes.contsList.map(({ id, checked }) => ({
          eva_id: id,
          is_option: checked ? 1 : 0
        })),
        eva_data_choose: orgEvaluatRes.eva_data_choose.map(({ id, is_option,content }) => ({
          eva_id: id,
          is_option: is_option === '是' ? 1 : 0,
          content:content,
        })),
      };
      saveEvaluat({
        org_eval_data: JSON.stringify(orgEvalData),
        tea_eval_data: JSON.stringify(teaEvalData),
        class_eval_data: JSON.stringify(evalDataClass),
        link_eval_data: JSON.stringify(evalDataLinkMan),
        c_id: this.classId
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          // this.goBack();
          this.$router.push({
        path: "/expireStudent/expire_index"
      });
        } else {
        }
      });
    },
    ratingInfo() {
      getStuRatingInfo({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          const { result } = data;
          const { class_info, eva_to_tea, eva_to_org,eva_data_goalkeeper,dataPhase, eva_data_physical,eva_to_class,eva_to_link } = result;
          if (dataPhase && dataPhase.length > 0){
            this.dataPhase={
              start_date:dataPhase[0].start_date,
              start_date1:dataPhase[1].start_date,
              end_date:dataPhase[0].end_date,
              end_date1:dataPhase[1].end_date,
            }
          }
          this.classInfo = {
            ...class_info,
            moment_picture: class_info.moment_picture
              ? HOSTURL + class_info.moment_picture
              : ""
          };

          const offTeachIds = String(this.$yioks
            .nullToStr(class_info.teacher_off_ids))
            .split(SPLIT_CHAR);
          const offTeachNames = this.$yioks
            .nullToStr(class_info.teacher_off_name)
            .split(SPLIT_CHAR);
          
          const eva_data_tea = [];
          const eva_data_tea_choose = [];
          eva_to_tea.map(item=>{
            if(item.template_type === 'check'){
              eva_data_tea.push(item);
            }
            if(item.template_type === 'choose'){
              let itt = {
                ...item,
                is_option:"",
                content:"",
              }
              eva_data_tea_choose.push(itt);
            }
          })
          
          this.teaEvaluatRes.push(...transData(offTeachIds, offTeachNames, eva_data_tea, "主讲师","official"));
          this.teaEvaluatRes.map(item=>{
            item.eva_data_choose =  transContsList(eva_data_tea_choose);
          })
          
          if(class_info.teacher_ids&&class_info.teacher_name){
            const teachersIds = this.$yioks
            .nullToStr(class_info.teacher_ids)
            .split(SPLIT_CHAR);
            const teachersNames = this.$yioks
            .nullToStr(class_info.teacher_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(teachersIds, teachersNames, eva_data_tea, "助理讲师","assistant"));
            this.teaEvaluatRes.map(item=>{
              item.eva_data_choose =  transContsList(eva_data_tea_choose);
            })
          }
          if(class_info.lecturer_assistant_ids&&class_info.lecturer_assistant_name){
            const lecturerAssistantIds = this.$yioks
            .nullToStr(class_info.lecturer_assistant_ids)
            .split(SPLIT_CHAR);
            const lecturerAssistantNames = this.$yioks
            .nullToStr(class_info.lecturer_assistant_name)
            .split(SPLIT_CHAR);
            this.teaEvaluatRes.push(...transData(lecturerAssistantIds, lecturerAssistantNames, eva_data_tea, "讲师助理","lecturer_assistant"));
            this.teaEvaluatRes.map(item=>{
              item.eva_data_choose =  transContsList(eva_data_tea_choose);
            })
          }
          if(eva_data_goalkeeper){
            const goalkeeperIds = ["0"];
            const goalkeeperNames = ["守门员专项讲师"];
            const eva_data = [];
            const eva_data_choose = [];
            eva_data_goalkeeper.map(item=>{
              if(item.template_type === 'check'){
                eva_data.push(item);
              }
              if(item.template_type === 'choose'){
                let itt = {
                  ...item,
                  is_option:"",
                  content:"",
                }
                eva_data_choose.push(itt);
              }
            })
            this.teaEvaluatRes.push(...transData(goalkeeperIds, goalkeeperNames, eva_data, "","goalkeeper"));
            this.teaEvaluatRes.map(item=>{
              if(item.name === '守门员专项讲师'){
                item.eva_data_choose =  transContsList(eva_data_choose);
              }
            })
          }
          if(eva_data_physical){
            const physicalIds = ["00"];
            const physicalNames = ["体能专项讲师"];
            const eva_data = [];
            const eva_data_choose = [];
            eva_data_physical.map(item=>{
              if(item.template_type === 'check'){
                eva_data.push(item);
              }
              if(item.template_type === 'choose'){
                let itt = {
                  ...item,
                  is_option:"",
                  content:"",
                }
                eva_data_choose.push(itt);
              }
            })
            this.teaEvaluatRes.push(...transData(physicalIds, physicalNames, eva_data, "","physical"));
            this.teaEvaluatRes.map(item=>{
              if(item.name === '体能专项讲师'){
                item.eva_data_choose =  transContsList(eva_data_choose);
              }
            })
          }
          if(eva_to_class){
            const classIds = [""];
            const classNames = ["培训班整体情况"];
            const eva_data = [];
            const eva_data_choose = [];
            eva_to_class.map(item=>{
              if(item.template_type === 'check'){
                eva_data.push(item);
              }
              if(item.template_type === 'choose'){
                let itt = {
                  ...item,
                  is_option:"",
                  content:"",
                }
                eva_data_choose.push(itt);
              }
            })
            this.teaEvaluatResClass.push(...transData(classIds, classNames, eva_data, "","class"));
            this.teaEvaluatResClass.map(item=>{
              item.eva_data_choose =  transContsList(eva_data_choose);
            })
          }
          if(eva_to_link){
            const linkIds = [""];
            const linkNames = ["协调员"];
            const eva_data = [];
            const eva_data_choose = [];
            eva_to_link.map(item=>{
              if(item.template_type === 'check'){
                eva_data.push(item);
              }
              if(item.template_type === 'choose'){
                let itt = {
                  ...item,
                  is_option:"",
                  content:"",
                }
                eva_data_choose.push(itt);
              }
            })
            this.teaEvaluatResLinkMan.push(...transData(linkIds, linkNames, eva_data, "","linkman"));
            this.teaEvaluatResLinkMan.map(item=>{
              item.eva_data_choose =  transContsList(eva_data_choose);
            })
          }
          
          let eva_to_org_data = [];
          let eva_to_org_data_choose = [];
          eva_to_org.map(item=>{
            if(item.template_type === 'check'){
              eva_to_org_data.push(item);
            }
            if(item.template_type === 'choose'){
              let itt = {
                ...item,
                is_option:"",
                content:"",
              }
              eva_to_org_data_choose.push(itt);
            }
          })
          this.orgEvaluatRes = {
            name: class_info.org_name,
            class_level : class_info.class_level,
            starNum: 0,
            theory_room_score: 0,
            practice_room_score: 0,
            eat_sleep_score: 0,
            practice_team_score: 0,
            train_clothing_socre: 0,
            suggest: "",
            contsList: eva_to_org_data.length > 0 ? transContsList(eva_to_org_data) : [],
            eva_data_choose: eva_to_org_data_choose.length > 0 ? transContsList(eva_to_org_data_choose) : [],
          };
        } else {
        }
      });
    },
    goBack() {
      this.backComfim = true;
    }
  },
};
</script>

<style lang="stylus">
@import '~@/assets/css/evaluation'
@import '~@/assets/css/evaluatUserShow'
.stu_create_evalua-root {
  .main-content-wrap .content-wrap .evalua-wrap {
    height: 470px;
  }
  .el-radio.is-bordered{
    color:white
  }
  .el-input__suffix{
    top:10px;
  }
}
</style>
